import React from 'react'
import { Cube } from '../geometries/Cube'
import { degreesToRadians } from '../helpers'

export const Bar = ({ position = [0, 0, 0], rotation = [0, 0, 0], height = 120, width = 50 }) => {
	return (
		<group position={position} scale={[1, 1, 1]} rotation={[0, degreesToRadians(rotation), 0]} castShadow receiveShadow>
			<Cube position={[0, 50, 0]} size={[width, 2.5, height]} />
			<Cube position={[0, 25, 0]} size={[2.5, 50, height]} />
			<Cube position={[0, 25, 0]} size={[width, 50, 2.5]} />
		</group>
	)
}
